module.exports = __webpack_public_path__ + "assets/853e2a9b-4057-42a5-ad7e-0762cda0b13c.58fc1eb7.svg";